import { render, staticRenderFns } from "./DisplayController.vue?vue&type=template&id=3a7e504b&scoped=true"
import script from "./DisplayController.vue?vue&type=script&lang=ts"
export * from "./DisplayController.vue?vue&type=script&lang=ts"
import style0 from "./DisplayController.vue?vue&type=style&index=0&id=3a7e504b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7e504b",
  null
  
)

export default component.exports